import React from "react";
import { Link } from "react-router-dom";
import { GraduationCap } from "lucide-react";

const PATTERN = "https://images.unsplash.com/photo-1542414110-ae27fdb87ee1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHxpc2xhbWljJTIwZ2VvbWV0cmljJTIwYXJjaGl0ZWN0dXJlJTIwbGlnaHR8ZW58MHx8fHwxNzg2MjgxODA4fDA&ixlib=rb-4.1.0&q=85";

export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      <div className="relative hidden overflow-hidden bg-navy lg:block">
        <img src={PATTERN} alt="" className="absolute inset-0 h-full w-full object-cover opacity-10" />
        <div className="relative flex h-full flex-col justify-between p-12">
          <Link to="/" className="flex items-center gap-3">
            <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-white/10 text-gold">
              <GraduationCap className="h-6 w-6" />
            </div>
            <div className="leading-tight text-white">
              <p className="font-heading text-base font-extrabold">سُفراء</p>
            </div>
          </Link>
          <div>
            <h2 className="font-heading text-3xl font-bold leading-[1.5] text-white">
              منصة علمية متكاملة <br /> لإدارة برامج مدينة حلب
            </h2>
            <p className="mt-4 max-w-md leading-[1.9] text-slate-300">
              تسجيل، حضور بالـ QR، واجبات، درجات، شهادات وتقارير — كل ذلك في مكان واحد أنيق وسهل.
            </p>
          </div>
          <p className="text-sm text-slate-400">© {new Date().getFullYear()} جميع الحقوق محفوظة</p>
        </div>
      </div>
      <div className="flex items-center justify-center bg-background p-6">
        <div className="w-full max-w-md animate-fade-up">
          <div className="mb-8 text-center lg:text-start">
            <h1 className="font-heading text-3xl font-extrabold text-navy">{title}</h1>
            <p className="mt-2 text-slate-500">{subtitle}</p>
          </div>
          {children}
          {footer && <div className="mt-6 text-center text-sm text-slate-500">{footer}</div>}
        </div>
      </div>
    </div>
  );
}
